import * as React from "react";

import { Separator } from "@replohq/lattice/components/separator/Separator";

export function AuthMethodDivider() {
  return (
    <div className="flex items-center gap-3 text-xs text-muted">
      <Separator className="flex-1" />
      or
      <Separator className="flex-1" />
    </div>
  );
}
